export const hasActiveSubscription = user => {
  if (!user) return false;
  return user.isAdmin || user.subscriptionActive === true;
};